export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7615.98f49e07.jpg";